import { IconBase, IconComponent } from './BaseIcon';

export const Ruler: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M28.9 9.7H0v12.6h32v-9.4a3.1 3.1 0 0 0-3.1-3.2Zm.8 10.3H2.3v-8h2.3v3.3h2.3V12H9v4.5h2.3V12h2.3v3.3H16V12h2.3v4.5h2.3V12h8.3c.4 0 .8.4.8.9Zm-3.4-6.3a2.3 2.3 0 1 0 2 3.4 2.3 2.3 0 0 0-2-3.4Z" />
  </IconBase>
);
